import api from '@pray/shared/utils/api';

export type SuperFunnelProductType = 'SF' | 'MM' | 'RADIO' | 'TV' | 'STUDIO' | 'OTHER';

export type SuperFunnelContractStatus =
  | 'draft'
  | 'active'
  | 'paused'
  | 'completed'
  | 'system'
  | 'canceled'
  | 'getting_assets'
  | 'set_to_run';

export type SuperFunnelAccountStatus = 'active' | 'inactive' | 'all';

export type SuperFunnelArStatus = 'current' | 'over_30' | 'over_60' | 'over_90' | 'none';

export type SuperFunnelLatestContract = {
  id: string;
  product_type: SuperFunnelProductType | null;
  types?: SuperFunnelProductType[];
  status: SuperFunnelContractStatus | null;
  exception_flag: boolean;
  contract_date: string | null;
  service_start_date: string | null;
  cancel_date: string | null;
  target_spend_pct: string | null;
};

export type SuperFunnelLatestArSnapshot = {
  ar_status: SuperFunnelArStatus | string;
  outstanding_over_30_cents: number;
};

export type SuperFunnelAccount = {
  organization_id: string;
  organization_name: string;
  hubspot_company_id: string | null;
  legal_entity_name: string | null;
  latest_contract: SuperFunnelLatestContract | null;
  latest_ar_snapshot: SuperFunnelLatestArSnapshot | null;
};

export type GetSuperFunnelAccountsParams = {
  ministry?: string;
  productType?: SuperFunnelProductType;
  contractStatus?: SuperFunnelContractStatus;
  accountStatus?: SuperFunnelAccountStatus;
  arStatus?: SuperFunnelArStatus;
  exceptionFlag?: boolean;
  limit?: number;
  offset?: number;
};

export type GetSuperFunnelAccountsResponse = {
  responded_at: string;
  object: 'list';
  data: SuperFunnelAccount[];
  data_count: number;
  last_item_identifier: number | null;
  total: number;
  limit: number;
  offset: number;
};

export const getAccounts = async ({
  ministry,
  productType,
  contractStatus,
  accountStatus,
  arStatus,
  exceptionFlag,
  limit,
  offset,
}: GetSuperFunnelAccountsParams = {}): Promise<GetSuperFunnelAccountsResponse> => {
  const params: Record<string, string | number | boolean> = {};

  if (ministry !== undefined) params.ministry = ministry;
  if (productType !== undefined) params.product_type = productType;
  if (contractStatus !== undefined) params.contract_status = contractStatus;
  if (accountStatus !== undefined) params.account_status = accountStatus;
  if (arStatus !== undefined) params.ar_status = arStatus;
  if (exceptionFlag !== undefined) params.exception_flag = exceptionFlag;
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;

  const url = '/web/studio/superfunnel/accounts';
  const response = await api.executeGetRequest(url, params);

  return response.data as GetSuperFunnelAccountsResponse;
};
